import React from 'react';
import { Link } from 'react-router-dom';
import { FaStar, FaShoppingCart, FaHeart, FaUser, FaHome, FaPhone, FaEnvelope } from 'react-icons/fa';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div>
            <h3>Novurem Patisserie</h3>
            <p>
              Boutique Konditorei in Ettlingen. Handgefertigte Pralinen, Macarons und Torten nach höchsten Standards.
            </p>
          </div>
          <div>
            <h3>Navigation</h3>
            <Link to="/">Startseite</Link>
            <Link to="/about">Über uns</Link>
            <Link to="/contact">Kontakt</Link>
            <Link to="/cart">Warenkorb</Link>
          </div>
          <div>
            <h3>Rechtliches</h3>
            <Link to="/privacy-policy">Datenschutz</Link>
            <Link to="/terms-conditions">AGB</Link>
            <Link to="/refund-policy">Widerrufsrecht</Link>
          </div>
          <div>
            <h3>Kontakt</h3>
            <p><FaPhone /> +4977081869489</p>
            <p>Email: <a href="mailto:novurem@hotmail.com">novurem@hotmail.com</a></p>
            <p><a href="https://wa.me/4977081869489">WhatsApp</a></p>
            <p><a href="https://viber.me/4977081869489">Viber</a></p>
            <p><FaHome /> Zehntwiesenstraße 33, 76275 Ettlingen</p>
            <p>Registernummer: 40607650</p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {year} Novurem Patisserie. Alle Rechte vorbehalten.</p>
        </div>
      </div>
    </footer>
  );
}